import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { Toaster } from 'sonner';
import { ThemeProvider, useTheme } from '@/components/theme/theme';
import { TooltipProvider } from '@/components/ui/tooltip';
import type { AuthClient } from '@/lib/auth/auth-client';
import { AuthProvider } from '@/lib/auth/session';

function ThemedToaster() {
  const { resolved } = useTheme();
  return <Toaster theme={resolved} position="top-right" richColors closeButton style={{ zIndex: 60 }} />;
}

export function AppProviders({
  queryClient,
  authClient,
  children,
}: {
  queryClient: QueryClient;
  authClient: AuthClient;
  children: ReactNode;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider client={authClient}>
        <ThemeProvider>
          <TooltipProvider>
            {children}
            <ThemedToaster />
          </TooltipProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
